// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.LandingHeader_mainHeader__iqQt9 {
  position: fixed;
  z-index: 9999;
  width: 100%;
  top: 0px;
  display: contents; }

.LandingHeader_header__WSYV4 {
  width: 100%;
  background-color: #275CE6; }

.LandingHeader_countryName__8zo6U {
  border-right: 1px solid #5588f7;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 16px; }
  .LandingHeader_countryName__8zo6U .LandingHeader_name__o8YpM {
    font-size: 20px !important;
    font-weight: 400 !important;
    margin-bottom: 5px !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_countryName__8zo6U {
      border-right: 0px; } }
  .LandingHeader_countryName__8zo6U .LandingHeader_countryLogo__z6ise {
    border-radius: 50%; }

.LandingHeader_countryNameMbl__I9kfJ {
  border-right: 1px solid #5588f7;
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 8px;
  padding-right: 16px; }
  .LandingHeader_countryNameMbl__I9kfJ .LandingHeader_name__o8YpM {
    font-size: 16px !important;
    font-weight: 400 !important;
    margin-bottom: 5px !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_countryNameMbl__I9kfJ {
      border-right: 0px; } }
  .LandingHeader_countryNameMbl__I9kfJ .LandingHeader_countryLogo__z6ise {
    border-radius: 50%; }

.LandingHeader_headertop__Llsv2 {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #5588F7; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_headertop__Llsv2 {
      border-bottom: none;
      height: 0; } }

.LandingHeader_dttReports__xRsOp {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 174px; }
  .LandingHeader_dttReports__xRsOp .LandingHeader_unileverLogo__B32s\\+ {
    width: 49px;
    height: 49px; }
  .LandingHeader_dttReports__xRsOp .LandingHeader_backArrow__JuNoJ {
    width: 24px;
    height: 24px; }
  .LandingHeader_dttReports__xRsOp p {
    width: 83px;
    font-size: 18px;
    font-weight: 400;
    line-height: 115%;
    margin-bottom: 8px !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_dttReports__xRsOp {
      display: none; } }

.LandingHeader_navlinks__AYEoq, .LandingHeader_menuSide__tWU81 {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  margin-right: 180px;
  gap: 14px;
  cursor: pointer; }
  .LandingHeader_navlinks__AYEoq p, .LandingHeader_menuSide__tWU81 p {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 0px; }
  .LandingHeader_navlinks__AYEoq span, .LandingHeader_menuSide__tWU81 span {
    display: none;
    gap: 8px;
    align-items: center;
    cursor: pointer; }
    .LandingHeader_navlinks__AYEoq span p, .LandingHeader_menuSide__tWU81 span p {
      font-weight: 400;
      font-size: 14px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_navlinks__AYEoq, .LandingHeader_menuSide__tWU81 {
      position: absolute;
      left: -200%; } }

.LandingHeader_profileIcon__0IfmL {
  margin-left: 20px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_profileIcon__0IfmL {
      display: none !important; } }

:root {
  --rt-opacity: 1 !important; }

.LandingHeader_popupModal__rtaTq {
  background-color: #FFFFFF !important;
  border-radius: 8px !important;
  padding: 16px !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 1; }
  .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ {
    width: 344px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    cursor: auto !important; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupDetails__dzkjD {
      padding: 18px 8px;
      width: 100%;
      border-radius: 8px;
      background-color: #F3F7FD; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupDetails__dzkjD h4 {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #333C43;
        line-height: 120%; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupDetails__dzkjD p {
        font-size: 14px;
        font-weight: 400;
        color: #333C43;
        line-height: 120%; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb {
      display: flex;
      flex-direction: row;
      gap: 10px;
      width: 100%;
      margin-top: 1rem;
      color: #333C43; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb .LandingHeader_title__EGtv1 {
        text-wrap: nowrap;
        font-weight: 600; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb .LandingHeader_display__FpFLc {
        max-width: -moz-fit-content;
        max-width: fit-content; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb .LandingHeader_toggle__-mSwa {
        display: flex;
        align-items: end;
        color: #275CE6;
        cursor: pointer; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupLogout__bqlcq {
      display: flex;
      flex-direction: row;
      padding: 10px;
      cursor: pointer;
      width: 100%; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupLogout__bqlcq p {
        color: #275CE6;
        font-weight: 600;
        font-size: 14px;
        padding-left: 8px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_popupModal__rtaTq {
      display: none; } }

.LandingHeader_sideMenuOptions__iu59s {
  min-height: 64px;
  display: none; }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_menuSide__tWU81 {
    position: absolute;
    left: 0;
    bottom: 0px;
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 999; } }

.LandingHeader_userName__Nc2\\+q {
  font-size: 20px !important;
  font-weight: 900 !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userName__Nc2\\+q {
      font-size: 16px !important; } }

.LandingHeader_username__FmzfW {
  margin-right: 180px;
  cursor: pointer; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_username__FmzfW {
      margin-right: 0px;
      padding-bottom: 4px !important; } }
  .LandingHeader_username__FmzfW .LandingHeader_userName__Nc2\\+q {
    font-size: 20px !important;
    font-weight: 900 !important; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_username__FmzfW .LandingHeader_userName__Nc2\\+q {
        font-size: 16px !important; } }

.LandingHeader_headerbottom__6MBUS, .LandingHeader_headerSidebar__O6\\+cf {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #275CE6; }
  .LandingHeader_headerbottom__6MBUS p, .LandingHeader_headerSidebar__O6\\+cf p {
    margin-bottom: 0px !important;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF; }
  .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
    display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_headerbottom__6MBUS, .LandingHeader_headerSidebar__O6\\+cf {
      height: 60px;
      justify-content: flex-end; }
      .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        margin-left: 18px;
        margin-right: auto; }
      .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z div, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z div {
        width: 20px;
        height: 2px;
        border-radius: 2px;
        background-color: #FFFFFF; }
      .LandingHeader_headerbottom__6MBUS p, .LandingHeader_headerSidebar__O6\\+cf p {
        margin-right: 16px;
        font-size: 16px;
        margin-bottom: 0 !important; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerSidebar__O6\\+cf {
    position: fixed;
    background-color: #275CE6;
    display: flex;
    flex-direction: column;
    height: 170px;
    width: 100%;
    justify-content: space-around;
    z-index: 999; }
    .LandingHeader_headerSidebar__O6\\+cf div,
    .LandingHeader_headerSidebar__O6\\+cf p {
      width: 100%;
      display: flex; }
    .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-left: 0;
      position: absolute;
      top: 22px;
      right: 22px; }
    .LandingHeader_headerSidebar__O6\\+cf p {
      font-size: 16px;
      position: absolute;
      bottom: 60px;
      left: 16px;
      width: auto; }
    .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_countryNameMbl__I9kfJ {
      display: none; } }

.LandingHeader_menuIcons__qQpou {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_menuIcons__qQpou {
      display: block; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_menuSide__tWU81 {
    border-radius: 24px 24px 0px 0px;
    padding-top: 32px;
    position: fixed;
    height: calc(100vh - 150px);
    padding-left: 16px;
    overflow: scroll;
    z-index: 2000; }
    .LandingHeader_menuSide__tWU81 div,
    .LandingHeader_menuSide__tWU81 span {
      display: flex;
      flex-direction: row;
      gap: 16px;
      align-items: center;
      text-align: center;
      width: 100%; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_logout__wCX5w {
    display: none; } }

.LandingHeader_logout_blue__Gzipb {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_logout_blue__Gzipb {
      display: block; } }

.LandingHeader_userHeaderMbl__ENplN {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userHeaderMbl__ENplN {
      display: block; } }

.LandingHeader_userHeaderDesktop__puXgz {
  display: block;
  margin-left: 180px;
  cursor: pointer; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userHeaderDesktop__puXgz {
      display: none; } }

.LandingHeader_headerbottom__6MBUS .LandingHeader_backButton__jpK3i p, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_backButton__jpK3i p {
  font-size: 16px; }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerbottom__6MBUS .LandingHeader_backButton__jpK3i, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_backButton__jpK3i {
    display: none; } }

.LandingHeader_dropdownConatiner__2TZ8c {
  display: flex;
  gap: 16px;
  height: 100%;
  padding: 0px 8px;
  align-items: center;
  margin-left: 180px; }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownWrapper__bapbM {
    display: flex;
    height: 100%; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_dropdownConatiner__2TZ8c {
      flex-direction: column !important;
      display: none; } }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownselected__L8W55 {
    background: #5588f7;
    border-bottom: 3px solid white; }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownselected__L8W55 span {
      font-weight: 600; }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm {
    position: relative;
    height: 100%;
    align-items: center;
    display: flex; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm {
        flex-direction: column !important; } }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm span {
      color: white;
      font-size: 14px;
      padding: 0px 8px; }
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm span {
          color: black; } }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt {
      position: absolute;
      z-index: 1;
      background: #275ce6;
      border-radius: 8px;
      padding: 1rem 0px;
      display: flex;
      width: 322px;
      flex-direction: column;
      align-items: flex-start;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      top: 90%;
      z-index: 9999; }
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+:hover {
        background-color: #5588f7;
        font-weight: 600; }
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ {
        font-size: 14px;
        font-weight: 400;
        color: white;
        width: 100%;
        padding: 8px 1rem; }

.LandingHeader_SMOMobileView__Q\\+Nvb {
  min-height: 64px; }

.LandingHeader_dropdownMobile__Evlmu {
  flex-direction: column !important;
  gap: 0px !important;
  height: max-content;
  justify-content: flex-start;
  font-size: 14px !important;
  align-items: flex-start !important;
  width: 100%; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 {
    margin-left: 0px;
    min-height: 64px;
    display: flex;
    justify-content: space-between;
    width: 100%; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 .LandingHeader_dropdownHeadingName__BuYZY {
      flex-basis: 75%; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 .LandingHeader_dropdownHeadingArrow__xlVSk {
      flex-basis: 25%;
      justify-content: center; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownArrowOpen__yKeps {
    transform: rotate(-90deg); }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownArrowClose__SYk5X {
    transform: rotate(90deg); }
  .LandingHeader_dropdownMobile__Evlmu span {
    width: 100%; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt {
    flex-direction: column !important;
    gap: 0px !important;
    overflow: scroll;
    width: calc(100% + 16px);
    margin-left: -16px !important; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ {
      margin: 0px !important;
      width: 100%;
      padding-left: calc(2.5rem + 16px);
      min-height: 48px; }
      .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ div {
        min-height: 48px; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownSelected__qgxoH {
      background: #f3f7fd; }

.LandingHeader_navLinkSelected__UWqIc {
  height: 100%;
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: #5588F7 !important;
  position: relative; }

.LandingHeader_navLinkSelected__UWqIc::after {
  content: "";
  border: 3px solid #F3F7FD;
  position: absolute;
  bottom: -2px;
  width: 102%;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1); }

.LandingHeader_adminDropdown__B11SS {
  position: relative; }
  .LandingHeader_adminDropdown__B11SS img:last-child {
    position: absolute;
    right: 16px;
    transform: rotate(90deg);
    transition: transform 0.1s ease-in-out; }
  .LandingHeader_adminDropdown__B11SS .LandingHeader_invertArrow__o-YrC {
    transform: rotate(-90deg) !important; }

.LandingHeader_adminDropdownOptions__xuOBS {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-start !important;
  padding-left: 38px; }
  .LandingHeader_adminDropdownOptions__xuOBS p {
    height: 40px;
    display: flex;
    align-items: center; }

.LandingHeader_dropdownCountry__G98p8 {
  width: 170px;
  flex-shrink: 0; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_dropdownCountry__G98p8 {
      width: 60px; } }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU {
    height: 100%;
    padding: 0px;
    background-color: #275CE6;
    border: none;
    outline: none;
    width: -moz-fit-content;
    width: fit-content;
    cursor: pointer; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU:hover {
      border: none;
      box-shadow: none;
      outline: none; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_countryName__8zo6U {
      border-right: 0;
      padding-right: 20px; }
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_countryName__8zo6U .LandingHeader_nameOption__OCLv2 {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 5px; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownArrow__jBYvj div {
      padding: 0;
      color: white; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownText__jiaCR {
      width: max-content;
      font-size: 90%;
      font-weight: 400;
      color: #FFFFFF;
      font-family: "Unilever Shilling", sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue" !important; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_seperator__EfkFC {
    display: none; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menu__kf0Us {
    width: -moz-fit-content;
    width: fit-content;
    overflow: hidden;
    border-radius: 5px; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menu__kf0Us {
        position: absolute;
        right: 15%; } }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuList__-jF0A {
    padding: 0;
    border-radius: 5px; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM {
    min-width: 100%;
    background-color: #FFFFFF;
    width: -moz-fit-content;
    width: fit-content;
    padding: 4px 4px;
    cursor: pointer;
    border-bottom: none; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_countryName__8zo6U {
      border-right: 0; }
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_countryName__8zo6U .LandingHeader_nameOption__OCLv2 {
        font-size: 16px;
        font-weight: 200;
        margin-bottom: 5px;
        color: #000000; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM:hover {
      background-color: #F3F7FD; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_selected__k7y7O {
      background-color: #F3F7FD; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components/LandingHomePage/LandingHeader/LandingHeader.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,gCAAgC;EAChC,+DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB,EAAA;;ACLpB;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,QAAQ;EACR,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,yBCVkB,EAAA;;ADapB;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB,EAAA;EALrB;IAOI,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B,EAAA;EDF/B;ICPF;MAaI,iBAAiB,EAAA,EAOpB;EApBD;IAkBI,kBAAkB,EAAA;;AAItB;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB,EAAA;EANrB;IAQI,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B,EAAA;EDzB/B;ICeF;MAcI,iBAAiB,EAAA,EAOpB;EArBD;IAmBI,kBAAkB,EAAA;;AAItB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCChEmB,EAAA;EFmBnB;ICsCF;MASI,mBAAmB;MACnB,SAAS,EAAA,EAEZ;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cCzEY;ED0EZ,eAAe;EAEf,kBAAkB,EAAA;EAPpB;IASI,WAAW;IACX,YAAY,EAAA;EAVhB;IAaI,WAAW;IACX,YAAY,EAAA;EAdhB;IAiBI,WAAW;IACX,eCpDqB;IDqDrB,gBC5CoB;ID6CpB,iBAAiB;IACjB,6BAA6B,EAAA;EDxE/B;ICmDF;MAyBI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cCrGY;EDsGZ,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAA;EAPjB;IASI,eCzEoB;ID0EpB,gBC/DoB;IDgEpB,kBAAkB,EAAA;EAXtB;IAcI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe,EAAA;IAjBnB;MAoBM,gBCzEkB;MD0ElB,eCrFkB,EAAA;EFftB;IC+EF;MA4BI,kBAAkB;MAClB,WAAW,EAAA,EAEd;;AACD;EACE,iBAAiB,EAAA;EDhHjB;IC+GF;MAGI,wBAAwB,EAAA,EAE3B;;AACD;EACE,0BAAa,EAAA;;AAEf;EACE,oCAAmC;EACnC,6BAA6B;EAC7B,wBAAwB;EACxB,+CAA+C;EAC/C,UAAU,EAAA;EALZ;IAOI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB,EAAA;IAX3B;MAaM,iBAAiB;MACjB,WAAW;MACX,kBAAkB;MAClB,yBClJkB,EAAA;MDkIxB;QAkBQ,eCxHqB;QDyHrB,gBC/GkB;QDgHlB,kBAAkB;QAClB,cCjJa;QDkJb,iBAAiB,EAAA;MAtBzB;QAyBQ,eClIgB;QDmIhB,gBCxHgB;QDyHhB,cCvJa;QDwJb,iBAAiB,EAAA;IA5BzB;MAgCM,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,gBAAgB;MAChB,cCjKe,EAAA;MD4HrB;QAuCQ,iBAAiB;QACjB,gBCpIkB,EAAA;MD4F1B;QA2CQ,2BAAsB;QAAtB,sBAAsB,EAAA;MA3C9B;QA8CQ,aAAa;QACb,gBAAgB;QAChB,cC5LY;QD6LZ,eAAe,EAAA;IAjDvB;MAqDM,aAAa;MACb,mBAAmB;MACnB,aAAa;MACb,eAAe;MACf,WAAW,EAAA;MAzDjB;QA2DQ,cCvMY;QDwMZ,gBCxJkB;QDyJlB,eCtKgB;QDuKhB,iBAAiB,EAAA;EDtLvB;ICwHF;MAmEI,aAAa,EAAA,EAEhB;;AACD;EACE,gBAAgB;EAChB,aAAa,EAAA;;ADhMb;ECmMF;IAGI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBC7NU;ID8NV,cCvNU;IDwNV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA,EAEf;;AACD;EACE,0BAA0B;EAC1B,2BAA2B,EAAA;EDrN3B;ICmNF;MAII,0BAA0B,EAAA,EAE7B;;AACD;EACE,mBAAmB;EACnB,eAAe,EAAA;ED5Nf;IC0NF;MAKI,iBAAiB;MACjB,8BAA8B,EAAA,EAUjC;EAhBD;IAUI,0BAA0B;IAC1B,2BAA2B,EAAA;IDrO7B;MC0NF;QAaM,0BAA0B,EAAA,EAE7B;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAE9B,mBAAmB;EACnB,yBCtQkB,EAAA;ED+PpB;IASI,6BAA6B;IAC7B,gBC3NoB;ID4NpB,eCvOoB;IDwOpB,cCzQU,EAAA;ED6Pd;IAeI,aAAa,EAAA;ED1Pf;IC2OF;MAkBI,YAAY;MACZ,yBAAyB,EAAA;MAnB7B;QAqBM,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;QACR,iBAAiB;QACjB,kBAAkB,EAAA;MA3BxB;QA8BM,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,yBC9RQ,EAAA;MD6Pd;QAoCM,kBAAkB;QAClB,eChQoB;QDiQpB,2BAA2B,EAAA,EAC5B;;ADlRH;ECqRF;IAGI,eAAe;IACf,yBC7SgB;ID8ShB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,YAAY,EAAA;IAVhB;;MAaM,WAAW;MACX,aAAa,EAAA;IAdnB;MAiBM,aAAa;MACb,yBAAyB;MACzB,qBAAqB;MACrB,cAAc;MACd,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAA;IAvBjB;MA0BM,eC/RoB;MDgSpB,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,WAAW,EAAA;IA9BjB;MAiCM,aAAa,EAAA,EACd;;AAGL;EACE,aAAa,EAAA;ED3Tb;IC0TF;MAGI,cAAc,EAAA,EAEjB;;AD/TC;ECmMF;IA+HI,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa,EAAA;IARjB;;MAWM,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,mBAAmB;MACnB,kBAAkB;MAClB,WAAW,EAAA,EACZ;;ADjVH;ECoVF;IAEI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa,EAAA;ED1Vb;ICyVF;MAGI,cAAc,EAAA,EAEjB;;AAMD;EACE,aAAa,EAAA;EDrWb;ICoWF;MAII,cAAc,EAAA,EAEjB;;AAED;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAA;ED/Wf;IC4WF;MAMI,aAAa,EAAA,EAEhB;;AAED;EAGM,eAAe,EAAA;;ADzXnB;ECsXF;IAOM,aAAa,EAAA,EAEhB;;AAOH;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;EANpB;IASI,aAAa;IACb,YAAY,EAAA;EDhZd;ICsYF;MAcI,iCAAiC;MACjC,aAAa,EAAA,EAyDhB;EAxED;IAmBI,mBAAmB;IACnB,8BAA8B,EAAA;IApBlC;MAsBM,gBAAgB,EAAA;EAtBtB;IA2BI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa,EAAA;IDpaf;MCsYF;QAiCM,iCAAiC,EAAA,EAsCpC;IAvEH;MAqCM,YAAY;MACZ,eAAe;MACf,gBAAgB,EAAA;MD7apB;QCsYF;UA0CQ,YAAY,EAAA,EAEf;IA5CL;MA8CM,kBAAkB;MAClB,UAAU;MACV,mBAAmB;MACnB,kBAAkB;MAClB,iBAAiB;MACjB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,2CAA2C;MAC3C,QAAQ;MACR,aAAa,EAAA;MAzDnB;QA4DQ,yBAAyB;QACzB,gBAAgB,EAAA;MA7DxB;QAgEQ,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,iBAAiB,EAAA;;AAMzB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW,EAAA;EAPb;IAUI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW,EAAA;IAdf;MAgBM,eAAe,EAAA;IAhBrB;MAmBM,eAAe;MACf,uBAAuB,EAAA;EApB7B;IAyBI,yBAAyB,EAAA;EAzB7B;IA6BI,wBAAwB,EAAA;EA7B5B;IAiCI,WAAW,EAAA;EAjCf;IAqCI,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,6BAA6B,EAAA;IAzCjC;MA4CM,sBAAsB;MACtB,WAAW;MACX,iCAAiC;MACjC,gBAAgB,EAAA;MA/CtB;QAiDQ,gBAAgB,EAAA;IAjDxB;MAqDM,mBAAmB,EAAA;;AAIzB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAGhB,oCAA0C;EAC1C,kBAAkB,EAAA;;AAEpB;EACE,WAAW;EACX,yBCtiBsB;EDuiBtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8CAA8C,EAAA;;AAEhD;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,sCAAsC,EAAA;EAN1C;IASI,oCAAoC,EAAA;;AAGxC;EACE,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB,EAAA;EALpB;IAQI,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,YAAY;EACZ,cAAc,EAAA;ED9jBd;IC4jBF;MAII,WAAW,EAAA,EAuFd;EA3FD;IAQI,YAAY;IACZ,YAAY;IACZ,yBC1lBgB;ID2lBhB,YAAY;IACZ,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe,EAAA;IAdnB;MAgBM,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;IAlBnB;MAqBM,eAAe;MACf,mBAAmB,EAAA;MAtBzB;QAwBQ,eAAe;QACf,gBAAgB;QAChB,kBAAkB,EAAA;IA1B1B;MAgCQ,UAAU;MACV,YAAY,EAAA;IAjCpB;MAsCM,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,cCvnBQ;MDwnBR,8LAEqE,EAAA;EA5C3E;IAiDI,aAAa,EAAA;EAjDjB;IAqDI,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB,EAAA;IDnnBpB;MC4jBF;QAyDM,kBAAkB;QAClB,UAAU,EAAA,EAEb;EA5DH;IA+DI,UAAU;IACV,kBAAkB,EAAA;EAhEtB;IAoEI,eAAe;IACf,yBCnpBU;IDopBV,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB,EAAA;IAzEvB;MA2EM,eAAe,EAAA;MA3ErB;QA6EQ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cCvpBM,EAAA;IDukBd;MAqFM,yBC3pBkB,EAAA;IDskBxB;MAwFM,yBC9pBkB,EAAA","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../../assets/styles/variables\";\n@import \"../../../assets/styles/mixin\";\n\n.mainHeader {\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  top: 0px;\n  display: contents;\n}\n\n.header {\n  width: 100%;\n  background-color: $primaryBlue;\n}\n\n.countryName {\n  border-right: 1px solid #5588f7;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-right: 16px;\n  .name {\n    font-size: 20px !important;\n    font-weight: 400 !important;\n    margin-bottom: 5px !important;\n  }\n\n  @include sm {\n    border-right: 0px;\n  }\n\n  .countryLogo {\n    // border: 1px solid white;\n    border-radius: 50%;\n  }\n}\n\n.countryNameMbl {\n  border-right: 1px solid #5588f7;\n  display: flex;\n  align-items: center;\n  justify-self: end;\n  gap: 8px;\n  padding-right: 16px;\n  .name {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    margin-bottom: 5px !important;\n  }\n\n  @include sm {\n    border-right: 0px;\n  }\n\n  .countryLogo {\n    // border: 1px solid white;\n    border-radius: 50%;\n  }\n}\n\n.headertop {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid $secondryBlue;\n  @include sm {\n    border-bottom: none;\n    height: 0;\n  }\n}\n.dttReports {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $white;\n  cursor: pointer;\n  // gap: 8px;\n  margin-left: 174px;\n  .unileverLogo {\n    width: 49px;\n    height: 49px;\n  }\n  .backArrow {\n    width: 24px;\n    height: 24px;\n  }\n  p {\n    width: 83px;\n    font-size: $font-size-md-large;\n    font-weight: $font-weight-normal;\n    line-height: 115%;\n    margin-bottom: 8px !important;\n  }\n\n  @include sm {\n    display: none;\n  }\n}\n.navlinks {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $white;\n  margin-right: 180px;\n  gap: 14px;\n  cursor: pointer;\n  p {\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    margin-bottom: 0px;\n  }\n  span {\n    display: none;\n    gap: 8px;\n    align-items: center;\n    cursor: pointer;\n    p {\n      // font-weight: $font-weight-semibold;\n      font-weight: $font-weight-normal;\n      font-size: $font-size-sm-base;\n    }\n  }\n  // img {\n  //   margin-bottom: 10px !important;\n  // }\n  @include sm {\n    position: absolute;\n    left: -200%;\n  }\n}\n.profileIcon {\n  margin-left: 20px;\n  @include sm {\n    display: none !important;\n  }\n}\n:root {\n  --rt-opacity: 1 !important;\n}\n.popupModal {\n  background-color: $white !important;\n  border-radius: 8px !important;\n  padding: 16px !important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  z-index: 1;\n  .popup {\n    width: 344px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    cursor: auto !important;\n    .popupDetails {\n      padding: 18px 8px;\n      width: 100%;\n      border-radius: 8px;\n      background-color: $timedetailsGrey;\n      h4 {\n        font-size: $font-size-md-xtraLarge;\n        font-weight: $font-weight-semibold;\n        margin-bottom: 8px;\n        color: $darkGreyText;\n        line-height: 120%;\n      }\n      p {\n        font-size: $font-size-sm-base;\n        font-weight: $font-weight-normal;\n        color: $darkGreyText;\n        line-height: 120%;\n      }\n    }\n    .dtAccess {\n      display: flex;\n      flex-direction: row;\n      gap: 10px;\n      width: 100%;\n      margin-top: 1rem;\n      color: $darkGreyText;\n      .title {\n        text-wrap: nowrap;\n        font-weight: $font-weight-semibold;\n      }\n      .display {\n        max-width: fit-content;\n      }\n      .toggle {\n        display: flex;\n        align-items: end;\n        color: $primaryBlue;\n        cursor: pointer;\n      }\n    }\n    .popupLogout {\n      display: flex;\n      flex-direction: row;\n      padding: 10px;\n      cursor: pointer;\n      width: 100%;\n      p {\n        color: $primaryBlue;\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-sm-base;\n        padding-left: 8px;\n      }\n    }\n  }\n  @include sm {\n    display: none;\n  }\n}\n.sideMenuOptions {\n  min-height: 64px;\n  display: none;\n}\n\n.menuSide {\n  @extend .navlinks;\n  @include sm {\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    height: 100%;\n    width: 100%;\n    background-color: $white;\n    color: $black;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 999;\n  }\n}\n.userName {\n  font-size: 20px !important;\n  font-weight: 900 !important;\n  @include sm {\n    font-size: 16px !important;\n  }\n}\n.username {\n  margin-right: 180px;\n  cursor: pointer;\n\n  @include sm {\n    margin-right: 0px;\n    padding-bottom: 4px !important;\n  }\n\n  .userName {\n    font-size: 20px !important;\n    font-weight: 900 !important;\n    @include sm {\n      font-size: 16px !important;\n    }\n  }\n}\n.headerbottom {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  // padding-left: 180px;\n  align-items: center;\n  background-color: $primaryBlue;\n  p {\n    margin-bottom: 0px !important;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-sm-base;\n    color: $white;\n  }\n  .hamMenu {\n    display: none;\n  }\n  @include sm {\n    height: 60px;\n    justify-content: flex-end;\n    .hamMenu {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      margin-left: 18px;\n      margin-right: auto;\n    }\n    .hamMenu div {\n      width: 20px;\n      height: 2px;\n      border-radius: 2px;\n      background-color: $white;\n    }\n    p {\n      margin-right: 16px;\n      font-size: $font-size-md-medium;\n      margin-bottom: 0 !important;\n    }\n  }\n}\n.headerSidebar {\n  @extend .headerbottom;\n  @include sm {\n    position: fixed;\n    background-color: $primaryBlue;\n    display: flex;\n    flex-direction: column;\n    height: 170px;\n    width: 100%;\n    justify-content: space-around;\n    z-index: 999;\n    div,\n    p {\n      width: 100%;\n      display: flex;\n    }\n    .hamMenu {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      margin-left: 0;\n      position: absolute;\n      top: 22px;\n      right: 22px;\n    }\n    p {\n      font-size: $font-size-md-medium;\n      position: absolute;\n      bottom: 60px;\n      left: 16px;\n      width: auto;\n    }\n    .countryNameMbl {\n      display: none;\n    }\n  }\n}\n.menuIcons {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n.menuSide {\n  @include sm {\n    border-radius: 24px 24px 0px 0px;\n    padding-top: 32px;\n    position: fixed;\n    height: calc(100vh - 150px);\n    padding-left: 16px;\n    overflow: scroll;\n    z-index: 2000;\n    div,\n    span {\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      align-items: center;\n      text-align: center;\n      width: 100%;\n    }\n  }\n}\n.logout {\n  @include sm {\n    display: none;\n  }\n}\n.logout_blue {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n\n.underLine {\n  // text-decoration: underline;\n}\n\n.userHeaderMbl {\n  display: none;\n\n  @include sm {\n    display: block;\n  }\n}\n\n.userHeaderDesktop {\n  display: block;\n  margin-left: 180px;\n  cursor: pointer;\n\n  @include sm {\n    display: none;\n  }\n}\n\n.headerbottom {\n  .backButton {\n    p {\n      font-size: 16px;\n    }\n\n    @include sm {\n      display: none;\n    }\n  }\n\n  // @include sm {\n  //   display: none;\n  // }\n}\n\n.dropdownConatiner {\n  display: flex;\n  gap: 16px;\n  height: 100%;\n  padding: 0px 8px;\n  align-items: center;\n  margin-left: 180px;\n\n  .dropdownWrapper {\n    display: flex;\n    height: 100%;\n  }\n\n  @include sm {\n    flex-direction: column !important;\n    display: none;\n  }\n\n  .dropdownselected {\n    background: #5588f7;\n    border-bottom: 3px solid white;\n    span {\n      font-weight: 600;\n    }\n  }\n\n  .dropdown {\n    position: relative;\n    height: 100%;\n    align-items: center;\n    display: flex;\n\n    @include sm {\n      flex-direction: column !important;\n    }\n\n    span {\n      color: white;\n      font-size: 14px;\n      padding: 0px 8px;\n\n      @include sm {\n        color: black;\n      }\n    }\n    .dropdownBody {\n      position: absolute;\n      z-index: 1;\n      background: #275ce6;\n      border-radius: 8px;\n      padding: 1rem 0px;\n      display: flex;\n      width: 322px;\n      flex-direction: column;\n      align-items: flex-start;\n      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n      top: 90%;\n      z-index: 9999;\n\n      .dropdownOptions:hover {\n        background-color: #5588f7;\n        font-weight: 600;\n      }\n      .dropdownOptions {\n        font-size: 14px;\n        font-weight: 400;\n        color: white;\n        width: 100%;\n        padding: 8px 1rem;\n      }\n    }\n  }\n}\n\n.SMOMobileView {\n  min-height: 64px;\n}\n\n.dropdownMobile {\n  flex-direction: column !important;\n  gap: 0px !important;\n  height: max-content;\n  justify-content: flex-start;\n  font-size: 14px !important;\n  align-items: flex-start !important;\n  width: 100%;\n\n  .dropdownHeading {\n    margin-left: 0px;\n    min-height: 64px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    .dropdownHeadingName {\n      flex-basis: 75%;\n    }\n    .dropdownHeadingArrow {\n      flex-basis: 25%;\n      justify-content: center;\n    }\n  }\n\n  .dropdownArrowOpen {\n    transform: rotate(-90deg);\n  }\n\n  .dropdownArrowClose {\n    transform: rotate(90deg);\n  }\n\n  span {\n    width: 100%;\n  }\n\n  .dropdownBody {\n    flex-direction: column !important;\n    gap: 0px !important;\n    overflow: scroll;\n    width: calc(100% + 16px);\n    margin-left: -16px !important;\n\n    .dropdownOptions {\n      margin: 0px !important;\n      width: 100%;\n      padding-left: calc(2.5rem + 16px);\n      min-height: 48px;\n      div {\n        min-height: 48px;\n      }\n    }\n    .dropdownSelected {\n      background: #f3f7fd;\n    }\n  }\n}\n.navLinkSelected {\n  height: 100%;\n  padding: 0px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  // border-bottom: 6px solid $timedetailsGrey;\n  // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.10);\n  background-color: $secondryBlue !important;\n  position: relative;\n}\n.navLinkSelected::after {\n  content: \"\";\n  border: 3px solid $timedetailsGrey;\n  position: absolute;\n  bottom: -2px;\n  width: 102%;\n  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);\n}\n.adminDropdown {\n  position: relative;\n  img:last-child {\n    position: absolute;\n    right: 16px;\n    transform: rotate(90deg);\n    transition: transform 0.1s ease-in-out;\n  }\n  .invertArrow {\n    transform: rotate(-90deg) !important;\n  }\n}\n.adminDropdownOptions {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: center;\n  align-items: flex-start !important;\n  padding-left: 38px;\n  // gap: 32px !important;\n  p {\n    height: 40px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.dropdownCountry {\n  width: 170px;\n  flex-shrink: 0;\n  @include sm {\n    width: 60px;\n  }\n\n  .dropdownControl {\n    height: 100%;\n    padding: 0px;\n    background-color: $primaryBlue;\n    border: none;\n    outline: none;\n    width: fit-content;\n    cursor: pointer;\n    &:hover {\n      border: none;\n      box-shadow: none;\n      outline: none;\n    }\n    .countryName {\n      border-right: 0;\n      padding-right: 20px;\n      .nameOption {\n        font-size: 20px;\n        font-weight: 400;\n        margin-bottom: 5px;\n      }\n    }\n\n    .dropdownArrow {\n      div {\n        padding: 0;\n        color: white;\n      }\n    }\n\n    .dropdownText {\n      width: max-content;\n      font-size: 90%;\n      font-weight: 400;\n      color: $white;\n      font-family: \"Unilever Shilling\", sans-serif, -apple-system,\n        BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n        \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\" !important;\n    }\n  }\n\n  .seperator {\n    display: none;\n  }\n\n  .menu {\n    width: fit-content;\n    overflow: hidden;\n    border-radius: 5px;\n    @include sm {\n      position: absolute;\n      right: 15%;\n    }\n  }\n\n  .menuList {\n    padding: 0;\n    border-radius: 5px;\n  }\n\n  .menuOption {\n    min-width: 100%;\n    background-color: $white;\n    width: fit-content;\n    padding: 4px 4px;\n    cursor: pointer;\n    border-bottom: none;\n    .countryName {\n      border-right: 0;\n      .nameOption {\n        font-size: 16px;\n        font-weight: 200;\n        margin-bottom: 5px;\n        color: $black;\n      }\n    }\n\n    &:hover {\n      background-color: $timedetailsGrey;\n    }\n    .selected {\n      background-color: $timedetailsGrey;\n    }\n  }\n}\n","// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Shilling';\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHeader": `LandingHeader_mainHeader__iqQt9`,
	"header": `LandingHeader_header__WSYV4`,
	"countryName": `LandingHeader_countryName__8zo6U`,
	"name": `LandingHeader_name__o8YpM`,
	"countryLogo": `LandingHeader_countryLogo__z6ise`,
	"countryNameMbl": `LandingHeader_countryNameMbl__I9kfJ`,
	"headertop": `LandingHeader_headertop__Llsv2`,
	"dttReports": `LandingHeader_dttReports__xRsOp`,
	"unileverLogo": `LandingHeader_unileverLogo__B32s+`,
	"backArrow": `LandingHeader_backArrow__JuNoJ`,
	"navlinks": `LandingHeader_navlinks__AYEoq`,
	"menuSide": `LandingHeader_menuSide__tWU81`,
	"profileIcon": `LandingHeader_profileIcon__0IfmL`,
	"popupModal": `LandingHeader_popupModal__rtaTq`,
	"popup": `LandingHeader_popup__yoe6+`,
	"popupDetails": `LandingHeader_popupDetails__dzkjD`,
	"dtAccess": `LandingHeader_dtAccess__ov8vb`,
	"title": `LandingHeader_title__EGtv1`,
	"display": `LandingHeader_display__FpFLc`,
	"toggle": `LandingHeader_toggle__-mSwa`,
	"popupLogout": `LandingHeader_popupLogout__bqlcq`,
	"sideMenuOptions": `LandingHeader_sideMenuOptions__iu59s`,
	"userName": `LandingHeader_userName__Nc2+q`,
	"username": `LandingHeader_username__FmzfW`,
	"headerbottom": `LandingHeader_headerbottom__6MBUS`,
	"headerSidebar": `LandingHeader_headerSidebar__O6+cf`,
	"hamMenu": `LandingHeader_hamMenu__h3l2Z`,
	"menuIcons": `LandingHeader_menuIcons__qQpou`,
	"logout": `LandingHeader_logout__wCX5w`,
	"logout_blue": `LandingHeader_logout_blue__Gzipb`,
	"userHeaderMbl": `LandingHeader_userHeaderMbl__ENplN`,
	"userHeaderDesktop": `LandingHeader_userHeaderDesktop__puXgz`,
	"backButton": `LandingHeader_backButton__jpK3i`,
	"dropdownConatiner": `LandingHeader_dropdownConatiner__2TZ8c`,
	"dropdownWrapper": `LandingHeader_dropdownWrapper__bapbM`,
	"dropdownselected": `LandingHeader_dropdownselected__L8W55`,
	"dropdown": `LandingHeader_dropdown__XvCUm`,
	"dropdownBody": `LandingHeader_dropdownBody__UPKTt`,
	"dropdownOptions": `LandingHeader_dropdownOptions__ceFP+`,
	"SMOMobileView": `LandingHeader_SMOMobileView__Q+Nvb`,
	"dropdownMobile": `LandingHeader_dropdownMobile__Evlmu`,
	"dropdownHeading": `LandingHeader_dropdownHeading__5Uhe6`,
	"dropdownHeadingName": `LandingHeader_dropdownHeadingName__BuYZY`,
	"dropdownHeadingArrow": `LandingHeader_dropdownHeadingArrow__xlVSk`,
	"dropdownArrowOpen": `LandingHeader_dropdownArrowOpen__yKeps`,
	"dropdownArrowClose": `LandingHeader_dropdownArrowClose__SYk5X`,
	"dropdownSelected": `LandingHeader_dropdownSelected__qgxoH`,
	"navLinkSelected": `LandingHeader_navLinkSelected__UWqIc`,
	"adminDropdown": `LandingHeader_adminDropdown__B11SS`,
	"invertArrow": `LandingHeader_invertArrow__o-YrC`,
	"adminDropdownOptions": `LandingHeader_adminDropdownOptions__xuOBS`,
	"dropdownCountry": `LandingHeader_dropdownCountry__G98p8`,
	"dropdownControl": `LandingHeader_dropdownControl__8T-SU`,
	"nameOption": `LandingHeader_nameOption__OCLv2`,
	"dropdownArrow": `LandingHeader_dropdownArrow__jBYvj`,
	"dropdownText": `LandingHeader_dropdownText__jiaCR`,
	"seperator": `LandingHeader_seperator__EfkFC`,
	"menu": `LandingHeader_menu__kf0Us`,
	"menuList": `LandingHeader_menuList__-jF0A`,
	"menuOption": `LandingHeader_menuOption__gvQFM`,
	"selected": `LandingHeader_selected__k7y7O`
};
export default ___CSS_LOADER_EXPORT___;
